import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, brandPrimaryHoverTint, header, white } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

const tabItemHeight = 48;
const tabListPadding = 16;

export const styleSheet = StyleSheet.create({
	container: { height: '100%' },
	body: {
		height: `calc(100% - ${tabItemHeight + tabListPadding}px)`,
		display: 'flex',
	},
	editorContainer: {
		height: '100%',
	},
	previewContainer: {
		flexGrow: 1,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	previewIframe: {
		flexGrow: 1,
	},
	previewIframeDisabled: {
		pointerEvents: 'none',
	},
	saveButton: {
		alignSelf: 'auto',
		height: 40,
	},
	splitContainer: {
		// Highlight the divider (ResizableHandle) on hover/drag.
		...CssSelectors.allDescendants(
			{
				':hover': {
					backgroundColor: brandPrimaryHoverTint,
				},
				':active': {
					backgroundColor: brandPrimaryHover,
				},
				transition: 'background-color 0.15s',
			},
			'[data-slot="resizable-handle"]'
		),
	},
	splitViewWindow: {
		boxSizing: 'border-box',
		height: '100%',
		minHeight: 0,
		minWidth: 0,
		overflow: 'hidden',
	},
	tabView: {
		height: '100%',
	},
	tabViewTablist: {
		background: 'white',
		borderBottom: `1px solid #d3dbde`,
		boxSizing: 'border-box',
		display: 'flex',
		height: tabItemHeight + tabListPadding,
		justifyContent: 'space-between',
		paddingTop: tabListPadding,
	},
	tabViewItem: {
		':focus-visible': {
			background: white,
			border: `1px solid ${brandPrimary}`,
			borderBottom: 'none',
		},
		':hover': {
			background: '#ddd5d533',
		},
		':not(:first-child)': {
			borderLeft: 'none',
			borderTopLeftRadius: 0,
		},
		':last-child': {
			borderTopRightRadius: 8,
		},
		alignItems: 'center',
		background: '#ddd5d552',
		border: `1px solid #d3dbde`,
		borderTopLeftRadius: 8,
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		flexGrow: 0,
		fontSize: 14,
		height: tabItemHeight,
		marginLeft: 1,
		paddingLeft: 20,
		paddingRight: 20,
		position: 'relative',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
	},
	tabViewSelectedItem: {
		':hover': {
			background: white,
		},
		background: white,
		borderBottom: '1px solid white',
		boxSizing: 'border-box',
		overflow: 'visible',
		position: 'relative',
	},
});
